// extracted by mini-css-extract-plugin
module.exports = {"items":"StageManager_items__25b7Y","add":"StageManager_add__3qfl6"};